import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSections, FormSubSections, ProgramContainer } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";
import { getRootComponent } from "../../utilities/ElementUtils";
import axios from "axios";
import LocalStorageService from "../../services/SessionStorageService";
import DataUtils from "../../utilities/DataUtils";
import { ErrorAlertComponent } from "../odsCalloutBox/ErrorAlertComponent";
import { SpinnerComponent } from "../../commonComponent/SpinnerComponent";
import SectionUtils from "../../utilities/SectionUtils";
import ReCaptchaV3 from "../captcha/CaptchComponent";
import ReCaptchaButton from "../captcha/captcha-button";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  isEng: boolean;
  callback,
  returnIndex?: number,
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
  callbackValidate?: (errors: any) => void
}

interface State {
  isBusy: boolean
  pageError: boolean;
}
export class ButtonComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

    this.state = {
      isBusy: false,
      pageError: false,
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
      if (this.state.pageError) {
          this.setState({ pageError: false });
          const firstHeader = document.querySelector('#error-container') as HTMLDivElement;
          if (firstHeader) {
            firstHeader.focus();
        } 
      }
  }

  arrayToString = (_a) => {
    if (Array.isArray(_a)) {
      return _a.join(' ');
    } else {
      return [_a]
    }
  }
  handleSubmitNoRecaptha = () => {
    this.handleButtonClick(null);
  }

  handleButtonClick = async (captchaToken?: string) => {
    const field = this.props.field;
    if (field.ValidateStep == 'Y') {
      const section = field.parent.parent as FormSections;
      const invalidControlList = FormValidationUtils.invalidControls(section);

      this.props.callbackValidate(invalidControlList);

      if (invalidControlList.length > 0) {
        const fieldFound = field.findFieldByName('Record__not__found');
        console.log(fieldFound);
        fieldFound.Visible = false;
        this.setState({ pageError: true });
        return
      } else {
        this.setState({ pageError: false });
      }
    }

    if (field.Api) {
      let programContainer = field.parent.parent.parent as ProgramContainer;
      const api = field.Api;
      const token = programContainer.Profile?.token;

      let entity = DataUtils.collectFormValue(programContainer);
      let headers;
      let response;
      //entity.email = programContainer.Profile?.email;
      if (field.Recaptcha) {
        entity.token = captchaToken;
      }
      entity.language = this.props.isEng ? "EN" : "FR";
      entity.userId = programContainer.Profile?.userId || '';
      entity.email = programContainer.Profile?.email || '';
      entity.firstName = programContainer.Profile?.firstName || '';
      entity.lastName = programContainer.Profile?.lastName || '';
      
      headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }

      try {
        this.setState({ isBusy: true });
        switch (field.SubmissionMethod) {
          case "post":
            response = await axios.post(api, entity, programContainer.AuthRequired == 'ps' && { headers: headers });
            break;
          case "get":
            response = await axios.get(api, programContainer.AuthRequired == 'ps' && { headers: headers });
            break;
          case "put":
            response = await axios.put(api, entity, programContainer.AuthRequired == 'ps' && { headers: headers });
            break;
        }

        this.setState({ isBusy: false });
        // if (response.status >= 400) {
        //   this.props.callbackStepIndex(5);
        //   return;
        // }
      } catch (ex) {
        console.log(ex);
        this.props.callbackStepIndex(9);
        return;
      }

      if (!response) {
        this.props.callbackStepIndex(9);
        return;
      }
     let currentEntity = response.data?.WebResponse; 
     if (!currentEntity) {
        const fieldFound = field.findFieldByName('Record__not__found');
        fieldFound.Visible = true;
        const threeTime = field.findFieldByName('3__time__limit__reached');
        threeTime.Visible = false;
        this.props.callback(programContainer);
        return;
      }
      
      if (currentEntity.statusCode == 2) {
        this.props.callbackStepIndex(7);
        //  this.props.callback(programContainer);
        return;
      }
      
      if (currentEntity.statusCode == 3) {
        this.props.callbackStepIndex(8);
        //  this.props.callback(programContainer);
        return;
      }

      if (currentEntity.statusCode == 5 ||currentEntity.statusCode == 55 ) {
        this.props.callbackStepIndex(9);
        return;
      }

      if (currentEntity.statusCode == 13) {
        this.props.callbackStepIndex(10);
        return;
      }
      programContainer.Entity= currentEntity.data;

      DataUtils.assignFormValue(programContainer);

      this.props.callback(programContainer);
    }

    FormValidationUtils.runJavascript(field);

    if (field.StepperScript) {
      const customJSFunc = eval(`(${field.StepperScript})`);
      customJSFunc((index) => {
        let destination = index;
        if (this.props.returnIndex != null) {
          destination = this.props.returnIndex;
          this.props.callbackStepIndex(destination);
        } else {
          if (typeof destination === "string") {
            const root = getRootComponent(field);
            const foundSection = root.ListOfFormSections.find(section => section.ENUTitle == destination);
            const indexNum = root.ListOfFormSections.filter(p => p.Visible).indexOf(foundSection);
            this.props.callbackStepIndex(indexNum)
          } else {
            this.props.callbackStepIndex(destination);
          }
        }
      });
    }

    this.props.callback(field.parent.parent.parent);
  }

  render() {
    let field = this.props.field;

    if (!field.Visible) return null;

    let controlArray = [];
    let title = this.props.isEng ? this.props.field.ENUTitle : this.props.field.FRATitle;

    if (field.InitScript && Utils.isNotNullOrEmpty(field.InitScript)) {
      const customJSFunc = eval(`(${field.InitScript})`);
      try {
        customJSFunc(field, process.env);
      } catch (ex) {
        console.log(ex);
      }
    }

    const ClassName = "ontario-button " + this.arrayToString(this.props.field.ClassName);
    controlArray.push(
      <div style={{textAlign: 'left', display: `${field.inlineStyling ? 'inline-block' : 'block'}`}} key={"button_" + field.parent.Sequence + "_" + field.Id}>
        {!field.Recaptcha && (
          <button className={ClassName} 
            id={`button_${field.parent.Sequence}_${field.Id}`}
            title={this.props.isEng ? field.ENUTitle : field.FRATitle}
            onClick={(e) => this.handleButtonClick()}
          >
            {title}
          </button>
        )}
        {field.Recaptcha && (
          <ReCaptchaV3 lang={this.props.isEng ? 'en' : 'fr'}>
            <ReCaptchaButton key={"recaptchbutton"}
                title={title}
                action={field.Recaptcha.action || 'submitAction'}
                buttonHandler={this.handleButtonClick}
            >
              {title}
            </ReCaptchaButton>
          </ReCaptchaV3>
        )}
        <div>
          <SpinnerComponent isBusy={this.state.isBusy} />
        </div>
      </div>);

    return controlArray;
  }
}